import { Brand } from '../models/brand';

// TODO: Remove DemoScenario, brandsForScenario, and MOCK_BRANDS when wired to a real API
export type DemoScenario = 'populated' | 'fewer' | 'single' | 'empty' | 'loading' | 'error';

export function brandsForScenario(scenario: DemoScenario): Brand[] {
    switch (scenario) {
        case 'fewer': return MOCK_BRANDS.slice(0, 3);
        case 'single': return MOCK_BRANDS.slice(0, 1);
        case 'empty': return [];
        default: return MOCK_BRANDS; // populated / loading / error
    }
}

export const MOCK_BRANDS: Brand[] = [
    new Brand({
        brandId: 9999,
        brandName: 'Green Valley Organics Co',
        upcCount: 3,
        createdDate: new Date('2025-03-22'),
    }),
    new Brand({
        brandId: 7777,
        brandName: 'Burts Bees',
        upcCount: 2,
        createdDate: new Date('2025-03-21'),
    }),
    new Brand({
        brandId: 5555,
        brandName: 'MCB Natural',
        upcCount: 1,
        createdDate: new Date('2025-03-20'),
    }),
    new Brand({
        brandId: 4444,
        brandName: 'Mill Creek Botanica',
        upcCount: 4,
        createdDate: new Date('2025-03-17'),
    }),
];
